export const getMockLogin = (state) => Number.parseInt(state.getIn(['config', 'mockLogin']), 10) === 1;
